import { useRef } from "react"; // ✅ ganti dari memo ke useRef
import Grid from "@mui/material/Grid";
import {
  AutocompleteInput,
  maxLength,
  minLength,
  number,
  ReferenceInput,
  required,
} from "react-admin";
import InputAdornment from "@mui/material/InputAdornment";
import {
  filterToQuery,
  inputText,
  matchSuggestion,
  OptionRenderer,
} from "../../../customerDebtPayments/common/CustomSelectOption";
import JournalAmount from "../../../customerDebtPayments/common/JournalAmount";
import parserFormatNumInput from "../../../../utils/parserFormatNumInput";
import useEnterToAddRowAndFocus from "../../../../utils/useEnterToAddRowAndFocus"; // ✅ import hook

const validateCode = [required(), minLength(36), maxLength(36)];
const validateAmount = [required(), number()];

const JournalInputs = ({ idSource, debitSource, creditSource, addRow }) => { // ✅ tambah addRow prop
  const creditRef = useRef(null); // ✅ ref untuk credit

  // 🔹 Enter di credit → tambah baris & fokus ke account
  useEnterToAddRowAndFocus(creditRef, addRow, 'input[name*="chart_of_account_id"]');

  return (
    <Grid
      container
      spacing={2}
      sx={{
        "& .MuiGrid-item": { py: 1 },
        mt: 0,
      }}
    >
      <Grid item xs={6}>
        <ReferenceInput
          source={idSource}
          reference="coa"
          perPage={10}
          sort={{ field: "code", order: "ASC" }}
        >
          <AutocompleteInput
            label="mine.label.account"
            variant="outlined"
            fullWidth
            validate={validateCode}
            optionValue="id"
            optionText={<OptionRenderer />}
            inputText={inputText}
            matchSuggestion={matchSuggestion}
            filterToQuery={filterToQuery}
            helperText={false}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={3}>
        <JournalAmount
          helperText={false}
          label="mine.label.debit"
          variant="outlined"
          source={debitSource}
          validate={validateAmount}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">Rp</InputAdornment>
            ),
          }}
          {...parserFormatNumInput}
          dependOn={["total", "", creditSource]}
        />
      </Grid>
      <Grid item xs={3} ref={creditRef}> {/* ✅ tambah ref di sini */}
        <JournalAmount
          helperText={false}
          label="mine.label.credit"
          variant="outlined"
          source={creditSource}
          validate={validateAmount}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">Rp</InputAdornment>
            ),
          }}
          {...parserFormatNumInput}
          dependOn={["total", "", debitSource]}
        />
      </Grid>
    </Grid>
  );
};

const Inputs = ({
  formData, // The whole form data
  scopedFormData, // The data for this item of the ArrayInput
  getSource, // A function to get the valid source inside an ArrayInput
  addRow, // ✅ tambah addRow prop
  ...rest
}) => {
  return (
    <JournalInputs
      {...scopedFormData}
      idSource={getSource("chart_of_account_id")}
      debitSource={getSource("debit")}
      creditSource={getSource("credit")}
      addRow={addRow} // ✅ diteruskan ke JournalInputs
    />
  );
};

export default Inputs;